import React, { FC } from 'react';
import { useAppSelector } from 'app/hooks/appHooks';
import { serverSelector, loadingSelector } from 'app/store/selectors';

type DumbLazyComponentProps = {
  fallback: React.ReactElement;
  children: React.ReactNode;
};

export const LazyComponent: FC<DumbLazyComponentProps> = ({ fallback, children, ...rest }) => {
  const server = useAppSelector(serverSelector);
  const loading = useAppSelector(loadingSelector);

  if (server || loading) {
    return fallback;
  }

  return (
    <React.Suspense fallback={fallback} {...rest}>
      {children}
    </React.Suspense>
  );
};
